<template>
    <div class="container">
        <!-- <div class="detail_box"> -->
            <el-form :model="form" size="mini" :inline="true" class="detail_form" >
                <div class="flex">
                    <el-form-item label="客户：">
                        <el-select class="input_box" v-model="form.param" placeholder="" size="mini">
                            <el-option value="1">123</el-option>
                            <el-option value="2">123</el-option>
                            <el-option value="3">123</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="销售日期：">
                        <el-date-picker class="filter_input" v-model="form.param" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="" label-width="70px">
                        <span>销售单号：xsdh1234564512</span>
                    </el-form-item>
                </div>
                <div class="operate_row">
                    <div class="">
                        <el-button type="danger" size="customize" @click="dialogVisible = !dialogVisible">提交审核</el-button>
                    </div>
                    <div class="">
                        <span class="excel_btn"><i class="excel-icon"></i>excel导出</span>
                    </div>
                </div>
                <div class="table_path">
                    <el-table :data="list" style="width: 100%" border height="100%" size="mini" header-cell-class-name="list_table_th">
                        <el-table-column type="index"></el-table-column>
                        <el-table-column type="selection"></el-table-column>
                        <el-table-column label="操作"></el-table-column>
                        <el-table-column label="资源状态"></el-table-column>
                        <el-table-column label="捆包号"></el-table-column>
                        <el-table-column label="品牌"></el-table-column>
                        <el-table-column label="品名"></el-table-column>
                        <el-table-column label="等级"></el-table-column>
                        <el-table-column label="厚度"></el-table-column>
                        <el-table-column label="长度"></el-table-column>
                        <el-table-column label="总宽度"></el-table-column>
                        <el-table-column label="销售立方"></el-table-column>
                        <el-table-column label="单价">
                            <template slot="header">
                                <span>单价</span>
                                <el-link type="danger" :underline="false">(批量)</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="金额"></el-table-column>
                        <el-table-column label="仓库"></el-table-column>
                        <el-table-column label="备注">
                            <template slot="header">
                                <span>备注</span>
                                <el-link type="danger" :underline="false">(批量)</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="footer">
                    <span>销售人：张思思</span>
                    <span>审核人：网上说</span>
                </div>
            </el-form>
        <!-- </div> -->

        <el-dialog v-dialog-drag title="宽度明细" :visible.sync="dialogVisible" width="623px">
            <div class="dialog_width_box">
                <div class="">宽度</div>
                <div class="width_row">
                    <div class="" v-for="n in 12" :key="n">
                        30
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" plain @click="dialogVisible = false">取消</el-button>
                <el-button size="mini" type="danger" @click="dialogVisible = false">确认</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
        .operate_row{
            display: flex; align-items: center; justify-content: space-between; padding: 28px 0 8px;
            // .excel_btn{
            //     color: #B21111; cursor: pointer;
            //     & + .excel_btn{ margin-left: 10px; }
            // }
        }
        .detail_form{
            position: relative; display: flex; flex-direction: column; align-items: stretch; height: 100%;
            & > .flex > div + div{ margin-left: 10px; }
            .input_box{ width: 120px; }
            .footer{ display: flex; justify-content: space-between; align-items: center; font-size: 16px; color: #333333; margin-top: 24px; }
        }
        .table_path{ flex: 1;}

        .dialog_width_box{
            width: 100%;
            & > div:first-child{ background: #EBE8E8; color: #333333; text-align: center; border: 1px solid #CCCCCC; border-bottom: 0px none; padding: 10px 0; }
            .width_row{
                display: flex; align-items: center; color: #155BD4; border-left: 1px solid #ccc;
                & > div{ flex: 1; text-align: center; border: 1px solid #CCCCCC; padding: 10px 0; border-left:0px none;}
            }
        }
    }
</style>
<script>
    export default {
        components:{
        },
        data(){
            return{
                tab : 1,

                last_page: 10,
                current_page: 1,
                total: 1000,
                list : [],
                form:{
                    param : ""
                },
                // dialog START
                dialogVisible : false,
                params:{
                    keyword: "",
                    belong: "",
                    project: "",
                    per_page: 20
                },
                // dialog END

            }
        },
        methods:{
            getPage(obj){
                this.current_page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
    }
</script>
